import * as types from "./mutation-types";

const state = () => {
  return {
    darkMode: false,
    passportInfo: 1,
    isShowBtn: false,
    loading: false,
    moneyCategories: []
  };
};

// getters
const getters = {
  darkMode: state => state.darkMode
};

// actions
const actions = {
  setDarkMode({ commit }, darkMode) {
    commit(types.SET_DARK_MODE, { darkMode });
  },
  setPassportInfo({ commit }, passportInfo) {
    commit(types.SET_PASSPORT_INFO, { passportInfo });
  },
  setIsShowBtn({ commit }, isShowBtn) {
    commit(types.SET_IS_SHOW_BTN, { isShowBtn });
  },
  setLoading({ commit }, loading) {
    // console.log(typeof loading);
    commit(types.SET_LOADING, { loading });
  },
  setMoneyCategories({ commit }, moneyCategories) {
    commit(types.SET_MONEY_CATEGORIES, { moneyCategories });
  }
};

// mutations
const mutations = {
  [types.SET_DARK_MODE](state, { darkMode }) {
    state.darkMode = darkMode;
  },
  [types.SET_PASSPORT_INFO](state, { passportInfo }) {
    state.passportInfo = passportInfo;
  },
  [types.SET_IS_SHOW_BTN](state, { isShowBtn }) {
    state.isShowBtn = isShowBtn;
  },
  [types.SET_LOADING](state, { loading }) {
    // console.log("state loading : ", loading);
    state.loading = loading;
  },
  [types.SET_MONEY_CATEGORIES](state, { moneyCategories }) {
    state.moneyCategories = moneyCategories;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
